import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPause = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.81813 2.3999C8.30256 2.3999 8.71049 2.80783 8.71049 3.29226V20.7073C8.71049 21.2173 8.30256 21.5997 7.81813 21.5997C7.33371 21.5997 6.92578 21.2172 6.92578 20.7073V3.29226C6.92578 2.80783 7.33371 2.3999 7.81813 2.3999V2.3999Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.2071 2.3999C16.6915 2.3999 17.0994 2.80783 17.0994 3.29226V20.7073C17.0994 21.2173 16.6915 21.5997 16.2071 21.5997C15.6971 21.5997 15.3147 21.2172 15.3147 20.7073V3.29226C15.3147 2.80783 15.6972 2.3999 16.2071 2.3999V2.3999Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgPause;
